import {connect} from 'react-redux';
import DropdownSelectColumns from './DropdownSelectColumns';

const mapStateToProps = ({
                           step9SavedColumns: {list}
                         }) => ({
  list
});

export default connect(
  mapStateToProps,
  null
)(DropdownSelectColumns);
